<div class="storage-location-badge">
  @for (badge of badges; track badge) {
    <div
      [class.recommended]="badge.type === 'Recommended'"
      [class.highly-rated]="badge.type === 'HighlyRated'"
      [class.open-late]="badge.type === 'OpenLate'"
      [class.honeymoon]="badge.type === 'Honeymoon'"
      >
      <i class="icon"></i>
      <span>{{ badge.text | translate }}</span>
    </div>
  }
</div>
